import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

/**
 * Serves one city's Section 8 PHA context. The full dataset (~60 KB) stays on
 * the server instead of shipping in every page's first-load code.
 */
export const fetchSection8CityContext = createServerFn({ method: "GET" })
  .inputValidator((d) => z.object({ state: z.string().max(80), city: z.string().max(120) }).parse(d))
  .handler(async ({ data }) => {
    const { getSection8CityContext } = await import("@/data/section8-city-context");
    return getSection8CityContext(data.state, data.city) ?? null;
  });
